<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">회원관리</span>
            <span class="txt">
                센터에 등록한 회원님을 검색하실 수 있으며, 회원님의 성함을 눌러 이용권 등록 및 마일리지 등록 등 회원님의
                다양한 설정을 진행하실 수 있습니다.
            </span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div style="display: flex; gap: 28px">
                <div class="photo-info-card">
                    <img
                        class="photo"
                        :src="customerInfo.imageUrl === null ? '/img/icons/no_photo.jpg' : customerInfo.imageUrl"
                        alt="사진"
                    />
                    <div class="info-txt">
                        <span class="txt name">{{ customerInfo.name + ` (${customerInfo.attendNo})` }}</span>
                        <span class="txt">{{ customerInfo.phone | phoneNumberFilter }}</span>
                        <span class="txt">{{ convertTeamGroupsToString(customerInfo.centerCustomerTeamGroups) }}</span>
                        <span class="txt">-</span>
                    </div>
                    <span v-if="customerInfo.status === 'V'" class="icon green">유효</span>
                    <span v-if="customerInfo.status === 'E'" class="icon red">만료</span>
                    <span v-if="customerInfo.status === '-'" class="icon gray">잠재</span>
                    <span v-if="customerInfo.status === 'H'" class="icon yellow">홀딩</span>
                    <!--<button class="send-btn">인증코드전송</button>-->
                </div>
                <div class="d-flex flex-column" style="margin-top: 35px">
                    <button
                        v-if="hasMessageEvent && customerInfo.mktAgreeSms"
                        class="com-btn white"
                        @click="routing('messageSend', customerInfo)"
                    >
                        메시지 발송
                    </button>
                    <button
                        v-show="isAllowed('ME', 6)"
                        class="com-btn white"
                        style="margin-top: 10px"
                        @click="showContractSendPopup()"
                    >
                        계약서 발송
                    </button>
                </div>
                <div class="info-card">
                    <div class="info-txt">
                        <span class="txt name">최근 수업일</span>
                        <span class="txt">{{ lastLessonDaysAgo }}일전</span>
                        <span class="txt">마지막 출석: {{ customerInfo.latestLessonAt | dateFormatFilter }}</span>
                    </div>
                </div>
            </div>
            <div class="com-tab">
                <button @click="onClickRouter('/madmin/member/info')">기본정보</button>
                <button
                    @click="
                        checkAllowedClick('LE', 1, () => {
                            onClickRouter('/madmin/member/payment');
                        })
                    "
                >
                    결제내역
                </button>
                <button @click="onClickRouter('/madmin/member/cancel')">예약/취소내역</button>
                <button @click="onClickRouter('/madmin/member/attend')">입장/출결내역</button>
                <button @click="onClickRouter('/madmin/member/mileage')">마일리지</button>
                <button class="on">상담내역</button>
                <button @click="onClickRouter('/madmin/member/message')">메시지발송내역</button>
                <button v-show="isAllowed('ME', 7)" @click="onClickRouter('/madmin/member/contract_send')">
                    계약서발송내역
                </button>
            </div>
            <loading-spinner v-if="editFieldIsLoading"></loading-spinner>
            <div v-else class="com-form-box">
                <div class="line">
                    <div class="sub">
                        <span class="tit">이름</span>
                        <input :value="customerInfo.name" class="w220" readonly type="text" />
                    </div>
                    <div class="sub">
                        <span class="tit">연락처</span>
                        <div class="input-cnt">
                            <div class="com-tel select-type">
                                <input v-model="editField.telNo[0]" maxlength="3" type="text" />
                                <input v-model="editField.telNo[1]" maxlength="4" type="text" />
                                <input v-model="editField.telNo[2]" maxlength="4" type="text" />
                            </div>
                        </div>
                    </div>
                    <div class="sub">
                        <span class="tit">
                            상담자
                            <span class="imp">*</span>
                        </span>
                        <!-- TODO 현재 로그인한 staffId를 default로 선택해줘야 하는데 현재 로그인 staffId를 알 수 없음 -->
                        <select-form
                            :select-data="['선택', ...centerStaffList]"
                            :select-value="['', ...centerStaffValueList]"
                            class="w220"
                            @update:set="(val) => (editField.centerStaffId = val)"
                        ></select-form>
                    </div>
                    <div class="sub">
                        <span class="tit">
                            상담일자
                            <span class="imp">*</span>
                        </span>
                        <single-calendar
                            :date="editField.consultedAt"
                            class="w220"
                            @update="(val) => (editField.consultedAt = val)"
                        ></single-calendar>
                    </div>
                    <div class="sub">
                        <span class="tit">
                            상담유형
                            <span class="imp">*</span>
                        </span>
                        <select-form
                            :select-data="['선택', ...consultType]"
                            :select-value="['', ...consultTypeValue]"
                            class="w220"
                            @update:set="onChangeConsultType"
                        ></select-form>
                        <button
                            class="com-setting-btn"
                            @click="
                                checkAllowedClick('MB', 4, () => {
                                    adviceSettingPop = true;
                                })
                            "
                        >
                            <span class="blind">설정</span>
                        </button>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">상담경로</span>
                    <div class="flex">
                        <div class="com-radio">
                            <input
                                id="radio-f1-1"
                                v-model="editField.consultPath"
                                name="radio-f1"
                                type="radio"
                                value="T"
                            />
                            <label for="radio-f1-1">전화</label>
                        </div>
                        <div class="com-radio">
                            <input
                                id="radio-f1-2"
                                v-model="editField.consultPath"
                                name="radio-f1"
                                type="radio"
                                value="V"
                            />
                            <label for="radio-f1-2">방문</label>
                        </div>
                        <div class="com-radio">
                            <input
                                id="radio-f1-3"
                                v-model="editField.consultPath"
                                name="radio-f1"
                                type="radio"
                                value="K"
                            />
                            <label for="radio-f1-3">카카오톡</label>
                        </div>
                        <div class="com-radio">
                            <input
                                id="radio-f1-4"
                                v-model="editField.consultPath"
                                name="radio-f1"
                                type="radio"
                                value="O"
                            />
                            <label for="radio-f1-4">온라인</label>
                        </div>
                        <div class="com-radio">
                            <input
                                id="radio-f1-5"
                                v-model="editField.consultPath"
                                name="radio-f1"
                                type="radio"
                                value="E"
                            />
                            <label for="radio-f1-5">기타</label>
                        </div>
                        <input
                            v-if="editField.consultPath === 'E'"
                            v-model="editField.consultPathEtc"
                            class="w200"
                            placeholder="상담 경로를 입력해주세요"
                            type="text"
                        />
                    </div>
                </div>
                <div class="line">
                    <span class="tit">유입경로</span>
                    <div class="input-cnt">
                        <select-form
                            :select-data="['유입경로', ...consultFunnel]"
                            :select-value="[0, ...consultFunnelValue]"
                            :selected-value="editField.centerConsultFunnelId"
                            class="w220"
                            @update:set="(val) => (editField.centerConsultFunnelId = val)"
                        ></select-form>
                        <button
                            class="com-setting-btn"
                            @click="
                                checkAllowedClick('MB', 4, () => {
                                    funnelSettingPop = true;
                                })
                            "
                        ></button>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">메모</span>
                    <ckeditor v-model="editField.memo" :config="editorConfig" :editor="editor"></ckeditor>
                </div>
            </div>
            <div class="bottom-btn">
                <button class="com-btn blue" @click="onClickCreateConsult">등록</button>
            </div>
            <div class="com-search-content">
                <div class="line">
                    <div class="com-calendar-wrap">
                        <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                        <div class="com-dash"><span class="dash">~</span></div>
                        <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                    </div>
                    <select-form
                        :select-data="['선택', ...periodTypeList]"
                        :select-value="['', ...periodTypeValueList]"
                        :selected-value="searchPeriod"
                        @update:set="(val) => (searchPeriod = val)"
                    ></select-form>
                </div>
                <div class="line">
                    <select-form
                        :select-data="['상담자', ...centerStaffList]"
                        :select-value="['', ...centerStaffValueList]"
                        @update:set="(val) => (centerStaffId = val)"
                    ></select-form>
                    <select-form
                        :select-data="['상담유형', ...consultType]"
                        :select-value="['', ...consultTypeValue]"
                        @update:set="(val) => (consultTypeId = val)"
                    ></select-form>
                    <button class="com-search-reset" @click="resetSearchParams"></button>
                </div>
            </div>
            <div class="com-table-content">
                <loading-spinner v-if="consultListIsLoading"></loading-spinner>
                <table v-else class="com-table">
                    <colgroup>
                        <col style="width: 160px" />
                        <col style="width: 110px" />
                        <col style="width: 140px" />
                        <col style="width: 140px" />
                        <col style="width: 110px" />
                        <col style="width: 110px" />
                        <col style="width: 425px" />
                        <col style="width: 110px" />
                        <col style="width: 110px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>상담일자</th>
                            <th>회원명</th>
                            <th>상담자</th>
                            <th>상담유형</th>
                            <th>상담경로</th>
                            <th>유입경로</th>
                            <th>상담내용</th>
                            <th>상담자</th>
                            <th>수정 / 삭제</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(c, index) in consultListInfo" :key="index">
                            <td>{{ c.c_consult_dt | timestampFilter }}</td>
                            <td>
                                <span>{{ c.c_cust_nm }}</span>
                            </td>
                            <td>{{ c.c_center_staff_nm }}</td>
                            <td>{{ c.c_consult_type_nm }}</td>
                            <td>{{ convertConsultPath(c.c_consult_path) }}</td>
                            <td>{{ c.c_info_path }}</td>

                            <td v-if="c.c_memo.includes('<img')">
                                <div
                                    @click="onClickModifyConsult(c.c_center_id, c.c_center_consult_id)"
                                    class="link line-2"
                                >
                                    상담내용에 사진이 포함되어 있습니다.
                                </div>
                            </td>
                            <td v-else>
                                <div
                                    @click="onClickModifyConsult(c.c_center_id, c.c_center_consult_id)"
                                    class="link line-2"
                                    v-html="c.c_memo.replaceAll('&nbsp;', '')"
                                ></div>
                            </td>
                            <td>{{ c.c_center_staff_nm }}</td>
                            <td>
                                <button
                                    style="
                                        width: 30px;
                                        height: 30px;
                                        background-image: url('/img/icons/table_modify_btn.png');
                                        background-size: 30px;
                                        margin-right: 10px;
                                    "
                                    @click="onClickModifyConsult(c.c_center_id, c.c_center_consult_id)"
                                >
                                    <span class="blind">수정하기</span>
                                </button>
                                <button
                                    style="
                                        width: 30px;
                                        height: 30px;
                                        background-image: url('/img/icons/ic_ad_del.png');
                                        background-size: 30px;
                                    "
                                    @click="onClickDeleteConsult(c.c_center_id, c.c_center_consult_id)"
                                >
                                    <span class="blind">삭제하기</span>
                                </button>
                            </td>
                        </tr>
                        <tr v-if="consultListInfo.length === 0">
                            <td colspan="100">등록된 내용이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <!--            <div v-for='(c, index) in consultListInfo' v-else :key='index' class='advice-view-content'>-->
            <!--                <div class='top-area'>-->
            <!--                    <span class='item'>-->
            <!--                        <span class='tit'>상담일자 :</span>-->
            <!--                        <span class='txt'>{{ c.c_consult_dt | timestampFilter }}</span>-->
            <!--                    </span>-->
            <!--                    <span class='item'>-->
            <!--                        <span class='tit'>회원명 :</span>-->
            <!--                        <span class='txt'>{{ c.c_cust_nm }}</span>-->
            <!--                    </span>-->
            <!--                    <span class='item'>-->
            <!--                        <span class='tit'>상담자 :</span>-->
            <!--                        <span class='txt'>{{ c.c_center_staff_nm }}</span>-->
            <!--                    </span>-->
            <!--                    <span class='item'>-->
            <!--                        <span class='tit'>상담유형 :</span>-->
            <!--                        <span class='txt'>{{ c.c_consult_type_nm }}</span>-->
            <!--                    </span>-->
            <!--                    <span class='item'>-->
            <!--                        <span class='tit'>상담경로 :</span>-->
            <!--                        <span class='txt'>{{ convertConsultPath(c.c_consult_path) }}</span>-->
            <!--                    </span>-->
            <!--                    <span class='item'>-->
            <!--                        <span class='tit'>유입경로 :</span>-->
            <!--                        <span class='txt'>{{ convertInfoPath(c.c_info_path) }}</span>-->
            <!--                    </span>-->
            <!--                    <button class='modify-btn' @click='onClickModifyConsult(c.c_center_id, c.c_center_consult_id)'><span-->
            <!--                        class='blind'>수정하기</span></button>-->
            <!--                    <button class='del-btn' @click='onClickDeleteConsult(c.c_center_id, c.c_center_consult_id)'><span-->
            <!--                        class='blind'>삭제하기</span></button>-->
            <!--                </div>-->
            <!--                <div class='view-area com-scroll-y'>-->
            <!--                    {{ c.c_memo }}-->
            <!--                </div>-->
            <!--            </div>-->
            <b-pagination
                v-model="consultPagingInfo.page"
                :per-page="consultPagingInfo.limit"
                :total-rows="consultPagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event, 'consult')"
            ></b-pagination>
            <!--        <div class="advice-view-content">-->
            <!--            <div class="top-area">-->
            <!--                <span class="item">-->
            <!--                    <span class="tit">최신상담일자 :</span>-->
            <!--                    <span class="txt">2019-12-23</span>-->
            <!--                </span>-->
            <!--                <span class="item">-->
            <!--                    <span class="tit">회원명 :</span>-->
            <!--                    <span class="txt">홍길동</span>-->
            <!--                </span>-->
            <!--                <span class="item">-->
            <!--                    <span class="tit">상담자 :</span>-->
            <!--                    <span class="txt">김윤경</span>-->
            <!--                </span>-->
            <!--                <span class="item">-->
            <!--                    <span class="tit">상담유형 :</span>-->
            <!--                    <span class="txt">등록</span>-->
            <!--                </span>-->
            <!--                <span class="item">-->
            <!--                    <span class="tit">상담경로 :</span>-->
            <!--                    <span class="txt">전화</span>-->
            <!--                </span>-->
            <!--                <span class="item">-->
            <!--                    <span class="tit">유입경로 :</span>-->
            <!--                    <span class="txt">전단지</span>-->
            <!--                </span>-->
            <!--                <button class="modify-btn" @click="advicePop = true"><span class="blind">수정하기</span></button>-->
            <!--                <button class="del-btn"><span class="blind">삭제하기</span></button>-->
            <!--            </div>-->
            <!--            <div class="view-area com-scroll-y">-->
            <!--                필라테스 3개월 다니다가 새로 옮기고 싶어서 문의 드렸다고 합니다. 1대1 개인레슨 가격 궁금해 하심. 허리 다친적 있으심.<br>-->
            <!--                퇴근 후 저녁 7~8시에 수업 시작 가능하심.-->
            <!--            </div>-->
            <!--        </div>-->
            <!--        <div class="advice-view-content">-->
            <!--            <div class="top-area">-->
            <!--                <span class="item">-->
            <!--                    <span class="tit">최신상담일자 :</span>-->
            <!--                    <span class="txt">2019-12-23</span>-->
            <!--                </span>-->
            <!--                <span class="item">-->
            <!--                    <span class="tit">회원명 :</span>-->
            <!--                    <span class="txt">홍길동</span>-->
            <!--                </span>-->
            <!--                <span class="item">-->
            <!--                    <span class="tit">상담자 :</span>-->
            <!--                    <span class="txt">김윤경</span>-->
            <!--                </span>-->
            <!--                <span class="item">-->
            <!--                    <span class="tit">상담유형 :</span>-->
            <!--                    <span class="txt">등록</span>-->
            <!--                </span>-->
            <!--                <span class="item">-->
            <!--                    <span class="tit">상담경로 :</span>-->
            <!--                    <span class="txt">전화</span>-->
            <!--                </span>-->
            <!--                <span class="item">-->
            <!--                    <span class="tit">유입경로 :</span>-->
            <!--                    <span class="txt">전단지</span>-->
            <!--                </span>-->
            <!--                <button class="modify-btn" @click="advicePop = true"><span class="blind">수정하기</span></button>-->
            <!--                <button class="del-btn"><span class="blind">삭제하기</span></button>-->
            <!--            </div>-->
            <!--            <div class="view-area com-scroll-y">-->
            <!--                필라테스 3개월 다니다가 새로 옮기고 싶어서 문의 드렸다고 합니다. 1대1 개인레슨 가격 궁금해 하심. 허리 다친적 있으심.<br>-->
            <!--                퇴근 후 저녁 7~8시에 수업 시작 가능하심.<br>-->
            <!--                필라테스 3개월 다니다가 새로 옮기고 싶어서 문의 드렸다고 합니다. 1대1 개인레슨 가격 궁금해 하심.<br>-->
            <!--                퇴근 후 저녁 7~8시에 수업 시작 가능하심.<br>-->
            <!--                어쩌구 저쩌구<br>-->
            <!--                어쩌구<br>-->
            <!--                어쩌구 저쩌구<br>-->
            <!--                어쩌구<br>-->
            <!--                어쩌구 저쩌구<br>-->
            <!--                어쩌구<br>-->
            <!--                어쩌구 저쩌구<br>-->
            <!--                어쩌구<br>-->
            <!--                저쩌구-->
            <!--            </div>-->
            <!--        </div>-->

            <!-- 상담내용 수정 레이어 팝업 -->
            <div v-show="advicePop" class="layer-pop square">
                <div class="view-content w1425">
                    <button class="close" @click="advicePop = false"><span class="blind">팝업 닫기</span></button>
                    <div class="scroll-area com-scroll-y">
                        <span class="title">상담내용 수정</span>
                        <div class="com-form-box">
                            <div class="line">
                                <div class="sub">
                                    <span class="tit">이름</span>
                                    <input
                                        v-model="detailEditField.customerNme"
                                        class="w220"
                                        readonly
                                        type="text"
                                        value="홍길동"
                                    />
                                </div>
                                <div class="sub">
                                    <span class="tit">
                                        상담자
                                        <span class="imp">*</span>
                                    </span>
                                    <select-form
                                        :select-data="['상담자', ...centerStaffList]"
                                        :select-value="['', ...centerStaffValueList]"
                                        :selected-value="detailEditField.centerStaffId"
                                        @update:set="(val) => (detailEditField.centerStaffId = val)"
                                    ></select-form>
                                </div>
                                <div class="sub">
                                    <span class="tit">상담일자</span>
                                    <single-calendar
                                        :date="detailEditField.consultedAt"
                                        class="w220"
                                        @update="(val) => (detailEditField.consultedAt = val)"
                                    ></single-calendar>
                                </div>
                                <div class="sub">
                                    <span class="tit">
                                        상담유형
                                        <span class="imp">*</span>
                                    </span>
                                    <select-form
                                        :select-data="['상담유형', ...consultType]"
                                        :select-value="['', ...consultTypeValue]"
                                        :selected-value="detailEditField.consultTypeId"
                                        @update:set="onChangeDetailConsultType"
                                    ></select-form>
                                    <button class="com-setting-btn" @click="adviceSettingPop = true">
                                        <span class="blind">설정</span>
                                    </button>
                                </div>
                            </div>
                            <div class="line">
                                <span class="tit">상담경로</span>
                                <div class="flex">
                                    <div class="com-radio">
                                        <input
                                            id="radio-f1-1"
                                            v-model="editField.consultPath"
                                            name="radio-f1"
                                            type="radio"
                                            value="T"
                                        />
                                        <label for="radio-f1-1">전화</label>
                                    </div>
                                    <div class="com-radio">
                                        <input
                                            id="radio-f1-2"
                                            v-model="editField.consultPath"
                                            name="radio-f1"
                                            type="radio"
                                            value="V"
                                        />
                                        <label for="radio-f1-2">방문</label>
                                    </div>
                                    <div class="com-radio">
                                        <input
                                            id="radio-f1-3"
                                            v-model="editField.consultPath"
                                            name="radio-f1"
                                            type="radio"
                                            value="K"
                                        />
                                        <label for="radio-f1-3">카카오톡</label>
                                    </div>
                                    <div class="com-radio">
                                        <input
                                            id="radio-f1-4"
                                            v-model="editField.consultPath"
                                            name="radio-f1"
                                            type="radio"
                                            value="O"
                                        />
                                        <label for="radio-f1-4">온라인</label>
                                    </div>
                                    <div class="com-radio">
                                        <input
                                            id="radio-f1-5"
                                            v-model="editField.consultPath"
                                            name="radio-f1"
                                            type="radio"
                                            value="E"
                                        />
                                        <label for="radio-f1-5">기타</label>
                                    </div>
                                    <input
                                        v-if="editField.consultPath === 'E'"
                                        v-model="editField.consultPathEtc"
                                        class="w200"
                                        placeholder="상담 경로를 입력해주세요"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div class="line">
                                <span class="tit">유입경로</span>
                                <select-form
                                    :select-data="['유입경로', ...consultFunnel]"
                                    :select-value="[0, ...consultFunnelValue]"
                                    :selected-value="detailEditField.centerConsultFunnelId"
                                    class="w220"
                                    @update:set="(val) => (detailEditField.centerConsultFunnelId = val)"
                                ></select-form>
                                <button
                                    class="com-setting-btn"
                                    @click="
                                        checkAllowedClick('MB', 4, () => {
                                            funnelSettingPop = true;
                                        })
                                    "
                                ></button>
                            </div>
                            <div class="line">
                                <span class="tit">메모</span>
                                <ckeditor
                                    v-model="detailEditField.memo"
                                    :config="editorConfig"
                                    :editor="editor"
                                ></ckeditor>
                            </div>
                        </div>

                        <div class="bottom-btn">
                            <button class="com-btn" @click="onClickCancleConsultDetail">취소</button>
                            <button class="com-btn blue" @click="onClickSaveConsultDetail">수정</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <!-- 상담유형 설정 팝업 -->
        <div v-show="adviceSettingPop" class="layer-pop square-type">
            <div class="view-content">
                <button class="close" @click="onClickCancleConsultType"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">상담유형 설정</span>
                    <p class="sub-txt">상담유형의 종류를 추가, 수정 및 삭제 할 수 있습니다.</p>
                    <loading-spinner v-if="consultPopupLoading"></loading-spinner>
                    <div v-else class="del-box">
                        <div class="input-cnt flex-col">
                            <div v-for="(c, index) in consultTypeList.types" class="line">
                                <input :key="index" ref="consultTypeArray" v-model="c.consultTypeName" type="text" />
                                <button class="com-btn" @click="onClickDeleteConsultType(c.centerConsultTypeId, index)">
                                    삭제
                                </button>
                            </div>
                        </div>
                        <div class="add-btn-cnt">
                            <div class="line">
                                <button class="com-btn" @click="onClickAddConsultType">+추가</button>
                            </div>
                        </div>
                    </div>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="onClickCancleConsultType">취소</button>
                        <button class="com-btn blue" @click="onClickSaveConsultType">저장</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 유입경로 설정 팝업 -->
        <div v-show="funnelSettingPop" class="layer-pop square-type">
            <div class="view-content">
                <button class="close" @click="onClickCancelConsultFunnel"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">유입경로 설정</span>
                    <p class="sub-txt">유입경로의 종류를 추가, 수정 및 삭제 할 수 있습니다.</p>
                    <loading-spinner v-if="consultPopupLoading"></loading-spinner>
                    <div v-else class="del-box">
                        <div class="input-cnt flex-col">
                            <div v-for="(c, index) in consultFunnelList.types" :key="index" class="line">
                                <input
                                    :key="index"
                                    ref="consultFunnelArray"
                                    v-model="c.consultFunnelName"
                                    type="text"
                                />
                                <button
                                    class="com-btn"
                                    @click="onClickDeleteConsultFunnel(c.centerConsultFunnelId, index)"
                                >
                                    삭제
                                </button>
                            </div>
                        </div>
                        <div class="add-btn-cnt">
                            <div class="line">
                                <button class="com-btn" @click="onClickAddConsultFunnel">+추가</button>
                            </div>
                        </div>
                    </div>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="onClickCancelConsultFunnel">취소</button>
                        <button class="com-btn blue" @click="onClickSaveConsultFunnel">저장</button>
                    </div>
                </div>
            </div>
        </div>
        <contract-send-dlg
            v-if="contractSendPop"
            :show="contractSendPop"
            :info="contractSendInfo"
            :close="handleCloseContractSend"
            :charge="handleCharge"
            :paymentLinkSend="handlePaymentLinkSend"
        ></contract-send-dlg>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { validateTelNo } from '@/assets/js/validation';
import moment from 'moment';
import EventBus from '../../../assets/js/eventBus';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import ClassicEditor from '@/assets/js/ckeditor/ckeditor';
import SimpleUpload from '@/assets/js/ckeditor/simpleUpload';
import ContractSendDlg from '../../../components/ContractSendDlg';

export default {
    name: 'memberAdvice',
    mixins: [MixinAllowedMenu],
    components: { LoadingSpinner, ContractSendDlg },
    props: {},
    computed: {
        fullTelNo() {
            const ed = this.editField;
            return `${ed.telNo[0]}${ed.telNo[1]}${ed.telNo[2]}`;
        },

        lastLessonDaysAgo() {
            if (this.customerInfo.latestLessonAt) {
                return moment().startOf('day').diff(moment(this.customerInfo.latestLessonAt).startOf('day'), 'days');
            }

            return '-';
        }
    },
    watch: {
        'editField.consultPath': function () {
            if (this.editField.consultPath !== 'E') {
                this.editField.consultPathEtc = '';
            }
        },
        'detailEditField.consultPath': function () {
            if (this.detailEditField.consultPath !== 'E') {
                this.detailEditField.consultPathEtc = '';
            }
        },
        'detailEditField.memo': function () {
            console.log(this.detailEditField.memo);
        },
        centerStaffId(newValue) {
            // 상담자
            this.fetchConsultList();
        },
        consultTypeId(newValue) {
            // 상담유형
            this.fetchConsultList();
        },
        searchPeriod(newValue) {
            // 검색 기간 설정 변수
            this.searchPeriod = newValue;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.initStartDate();
                this.initEndDate();
            }
            this.fetchConsultList();
        },
        startDate(newValue) {
            // 검색 시작일
            this.startDate = newValue;
        },
        endDate(newValue) {
            // 검색 종료일
            this.endDate = newValue;
        },
    },
    mounted() {
        this.init();
    },
    data() {
        return {
            hasMessageEvent: false, // 메시지 계약되었을시..

            advicePop: false, // 상담내용 수정 팝업 flag
            adviceSettingPop: false, // 상담유형 수정 팝업 flag
            isLoading: false, // 페이지 초기 로딩 flag
            consultListIsLoading: false, // 상담내역 목록 로딩 flag
            consultPopupLoading: false, // 상담유형 팝업 로딩 flag
            editFieldIsLoading: false, // 상담등록 필드 로딩 flag
            centerId: this.$route.params.id,
            customerId: this.$route.query.customerId,
            customerInfo: {}, // 회원 정보

            editField: {
                customerYn: true,
                customerNme: '',
                consultedAt: moment().format('YYYY-MM-DD'), // 오늘로 기본세팅(21.03.17)
                consultPath: 'T',
                centerConsultFunnelId: 0,
                memo: '',
                consultTypeId: '',
                consultTypeName: '',
                centerStaffId: '',
                telNo: ['', '', ''], // 전화번호
                consultPathEtc: '',
            },

            detailEditField: {
                // 상담 내용 수정 editField
                consultPathEtc: '',
                customerYn: true,
                customerNme: '',
                consultedAt: '',
                consultPath: 'T',
                centerConsultFunnelId: 0,
                memo: '',
                consultTypeId: '',
                consultTypeName: '',
                centerStaffId: '',
            },

            centerStaffList: [], // centerStaff(상담자) 이름 목록
            centerStaffValueList: [], // centerStaff(상담자) ID 목록

            consultListInfo: [], // 상담목록 가공전
            consultTypeList: {
                types: [],
            },
            consultType: [],
            consultTypeValue: [],
            consultPagingInfo: {
                page: 1, // 현재 페이지
                limit: 3, // 한 목록에 표출되는 건수
                totalItems: '', // 총 Item 수
                itemCount: '', // 현재 페이지 item 수
                totalPages: '', // 총 페이지 수
                route: '', // 링크 경로 생성시 프리픽스
            },
            consultTypeId: '', // 상담유형 검색 파라미터
            centerStaffId: '', // 상담자 검색 파라미터

            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],

            searchPeriod: '', // 검색 기간 설정
            startDate: '', // 검색 시작일
            endDate: '', // 검색 종료일

            consultFunnel: [],
            consultFunnelValue: [],
            editor: ClassicEditor,
            editorConfig: {
                extraPlugins: [SimpleUpload],
                height: '500px',
                language: 'ko',
                simpleUpload: {
                    uploadUrl: '/admin/api/board/file',
                    headers: {
                        'X-CSRF-TOKEN': 'CSRF-Token',
                    },
                },
            },
            funnelSettingPop: false,
            consultFunnelList: {
                types: [],
            },

            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            detailConsultLoading: false,

            contractSendPop: false,
            contractSendInfo: {},
            centerInfo: {},
        };
    },
    methods: {
        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.consultPagingInfo.limit = val;
            this.fetchConsultList();
        },

        // 유입경로 유형 삭제 API 호출
        sendDeleteConsultFunnel(consultFunnelId) {
            return api.delete(`/admin/api/center/${this.centerId}/consult-Funnel/${consultFunnelId}`);
        },

        sendPostSaveConsultFunnel() {
            return api.post(`/admin/api/center/${this.centerId}/consult-Funnel`, {
                centerConsultFunnelInput: this.consultFunnelList.types,
            });
        },

        // 유입경로 삭제 버튼 클릭시
        async onClickDeleteConsultFunnel(consultFunnelId, index) {
            if (!confirm('유입경로를 삭제하시겠습니까?')) {
                return false;
            }
            try {
                if (consultFunnelId === undefined) {
                    this.consultFunnelList.types.splice(index, 1);
                } else {
                    this.consultPopupLoading = true;
                    await this.sendDeleteConsultFunnel(consultFunnelId);
                    alert('유입경로 삭제했습니다.');
                    await this.fetchConsultFunnel();
                    this.consultPopupLoading = false;
                }
            } catch (error) {
                this.consultPopupLoading = false;
                alert('유입경로 삭제 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 상담유형 설정 팝업에서 저장 버튼 클릭시
        async onClickSaveConsultFunnel() {
            for (const element of this.consultFunnelList.types) {
                if (element.consultFunnelName == '') {
                    alert('유입경로를 입력해주세요');
                    return;
                }
            }

            try {
                this.consultPopupLoading = true;
                await this.sendPostSaveConsultFunnel();
                alert('유입경로를 저장했습니다.');
                await this.fetchConsultFunnel(); // 상담유형 다시 불러오기
                this.consultPopupLoading = false;
            } catch (error) {
                this.consultPopupLoading = false;
                alert('유입경로 저장 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 유입경로 추가 버튼 클릭시
        onClickAddConsultFunnel() {
            this.consultFunnelList.types.push({
                consultFunnelName: '',
            });
        },

        // 상담유형 설정 팝업에서 취소 버튼 클릭시
        async onClickCancelConsultFunnel() {
            this.funnelSettingPop = false;
            await this.fetchConsultFunnel();
        },

        routing(toName, checkedUserData) {
            const routingData = [];
            console.log(checkedUserData);
            // checkedUserData.forEach((param) => {
            const tempValue = {
                ...checkedUserData,
            };
            routingData.push(tempValue);
            // });
            this.$router.push({
                name: toName,
                params: { data: routingData },
            });
        },

        checkMessageEvent() {
            return api
                .get('/admin/api/center/ftcontract/sms')
                .then((res) => {
                    this.hasMessageEvent = JSON.parse(res.data);
                })
                .catch((error) => {
                    this.hasMessageEvent = false;
                });
        },

        // 초기화
        async init() {
            this.isLoading = true;
            this.consultPagingInfo.limit = 3; // 상담내역은 페이지당 데이터 개수를 3개로 설정
            await this.fetchCustomerDetail(); // 회원 정보 가져오기
            await this.fetchConsultType(); // 상담유형 목록 가져오기
            await this.fetchConsultFunnel(); // 상담유형 목록 가져오기
            await this.fetchConsultList(); // 상담목록 가져오기
            await this.fetchCenterStaffList(); // 직원(상담자) 목록 가져오기
            await this.initStartDate(); // 검색 시작일 초기화
            await this.initEndDate(); // 검색 종료일 초기화
            await this.checkMessageEvent();
            this.getCenterInfo(); // 로그인한 센터 정보 가져오기
            this.editField.customerNme = this.customerInfo.name; // 회원 이름 default 세팅
            this.editField.telNo = this.splitPhoneNumber(this.customerInfo.phone); // 폰번호
            this.detailEditField.customerNme = this.customerInfo.name; // 상담 수정 팝업 회원 이름 default 세팅
            this.isLoading = false;
        },
        // centerId 로 센터 정보 가져오기
        async getCenterInfo() {
            try {
                const { data } = await this.sendGetCenter();
                this.centerInfo = data;
            } catch (error) {
                console.log(error);
            }
        },

        // 센터 조회 API 호출
        sendGetCenter() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },

        fetchConsultFunnel() {
            this.consultFunnel = [];
            this.consultFunnelValue = [];
            this.consultFunnelList.types = [];
            return api.get(`/admin/api/center/${this.centerId}/consult-funnel`).then((res) => {
                res.data.map((element) => {
                    this.consultFunnel.push(element.c_consult_funnel_nm);
                    this.consultFunnelValue.push(element.c_center_consult_funnel_id);
                    this.consultFunnelList.types.push({
                        consultFunnelName: element.c_consult_funnel_nm,
                        centerConsultFunnelId: element.c_center_consult_funnel_id,
                    });
                });
            });
        },

        // 회원 정보 가져오기
        async fetchCustomerDetail() {
            try {
                const { data } = await this.sendGetCustomerDetail();
                this.customerInfo = data;
                this.customerInfo.centerCustomerTeamGroups = this.customerInfo.centerCustomerTeamGroups.filter(
                    (g) => !g.centerCustomerTeam.info.deleteYn
                );
            } catch (error) {
                alert('회원정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 회원 기본정보 조회 API 호출
        sendGetCustomerDetail() {
            return api.get(`/admin/api/center/${this.centerId}/customer/${this.customerId}`);
        },

        // 직원(상담자) 목록 가져오기
        async fetchCenterStaffList() {
            try {
                const { data } = await this.sendGetCenterStaffList();
                data.forEach((d) => {
                    this.centerStaffList.push(d.name);
                    this.centerStaffValueList.push(d.centerStaffId);
                });
            } catch (error) {
                alert('직원 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 직원 목록 API 호출
        sendGetCenterStaffList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },

        // 상담유형 select-form 변경시
        onChangeConsultType(val) {
            const index = this.consultTypeList.types.findIndex((c) => c.centerConsultTypeId === val); // consultTypeId로 consultTypeName을 찾기 위해 index를 구함
            this.editField.consultTypeName = this.consultType[index];
            this.editField.consultTypeId = val;
        },

        // 상담 유형 가져오기
        async fetchConsultType() {
            try {
                // 상담 유형 관련 변수 초기화
                this.consultTypeList = {
                    types: [],
                };
                this.consultType = [];
                this.consultTypeValue = [];

                const { data } = await this.sendGetConsultType();
                data.forEach((c) => {
                    // select-form 셋팅
                    this.consultType.push(c.c_consult_type_nm);
                    this.consultTypeValue.push(c.c_center_consult_type_id);

                    const temp = {
                        centerConsultTypeId: c.c_center_consult_type_id,
                        consultTypeName: c.c_consult_type_nm,
                    };
                    this.consultTypeList.types.push(temp);
                });
            } catch (error) {
                alert('상담 유형을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 상담 유형 목록 조회 API 호출
        sendGetConsultType() {
            return api.get(`/admin/api/center/${this.centerId}/consult-type`);
        },

        // 상담 등록 버튼 클릭시
        async onClickCreateConsult() {
            const validate = this.validateValues();
            if (!validate.result) {
                alert(validate.msg);
                return false;
            }
            try {
                this.editFieldIsLoading = true;
                const { data } = await this.sendPostCreateConsult();
                alert('상담내역이 등록 되었습니다.');
                await this.fetchConsultList();
                this.initEditField(); // 상담 등록 후 상담 관리 등록 내용 초기화
                this.editFieldIsLoading = false;
            } catch (error) {
                alert('상담 등록 중 오류가 발생했습니다.');
                console.log(error);
                this.editFieldIsLoading = false;
            }
        },

        // 상담관리 등록시 필수값 체크
        validateValues() {
            // 필수값 체크
            let result = false;
            const { customerNme, consultTypeId, centerStaffId, consultedAt } = this.editField;
            let msg = '';

            // 이름
            if (customerNme.trim() === '') {
                msg = '이름을 입력하세요.';
                return { result, msg };
            }
            if (customerNme.trim().length < 2) {
                msg = '이름을 다시 입력하세요.';
                return { result, msg };
            }

            // 연락처, 필수값 아니나 입력을 했으면 validate
            if (this.fullTelNo.length > 0 && !validateTelNo(this.fullTelNo)) {
                msg = '연락처를 다시 확인하세요.';
                return { result, msg };
            }

            if (!consultedAt) {
                msg = '상담일자를 선택하세요.';
                return { result, msg };
            }

            if (!consultTypeId) {
                msg = '상담유형을 선택하세요.';
                return { result, msg };
            }

            if (!centerStaffId) {
                msg = '상담자를 선택하세요.';
                return { result, msg };
            }
            result = true;
            return { result };
        },

        // 상담 관리 내용 초기화
        initEditField() {
            const init = {
                customerYn: true,
                customerNme: this.customerInfo.name,
                consultedAt: '',
                consultPath: 'T',
                centerConsultFunnelId: 0,
                memo: '',
                consultTypeId: '',
                consultTypeName: '',
                centerStaffId: '',
                telNo: this.splitPhoneNumber(this.customerInfo.phone), // 번호관련 초기화
            };
            this.editField = init;
        },
        // 상담 관리 내용 초기화
        initDetailEditField() {
            const init = {
                customerNme: '',
                consultedAt: '',
                consultPath: 'T',
                centerConsultFunnelId: 0,
                memo: '',
                consultTypeId: '',
                consultTypeName: '',
                centerStaffId: '',
                telNo: this.splitPhoneNumber(this.customerInfo.phone), // 번호관련 초기화
            };
            this.detailEditField = init;
        },

        // 센터 상담관리 생성 API 호출
        sendPostCreateConsult() {
            const params = this.getCreateParams();
            return api.post(`/admin/api/center/${this.centerId}/consult`, {
                ...params,
            });
        },

        // 센터 상담관리 생성 파라미터 가공
        getCreateParams() {
            const domEditableElement = document.querySelector('.ck-editor__editable');
            const editorInstance = domEditableElement.ckeditorInstance;
            this.editField.memo = editorInstance.getData();

            const { customerId } = this;
            const {
                customerYn,
                customerNme,
                consultedAt,
                consultPath,
                consultPathEtc,
                infoPath,
                memo,
                centerStaffId,
                consultTypeId,
                consultTypeName,
                centerConsultFunnelId,
            } = this.editField;
            const telNo = this.fullTelNo;

            const params = {
                customerYn,
                customerId,
                customerNme,
                telNo,
                centerStaffId,
                consultedAt,
                consultTypeId,
                consultTypeName,
                consultPath,
                consultPathEtc,
                centerConsultFunnelId,
                memo,
            };

            if (centerStaffId === '') {
                delete params.centerStaffId;
            } else if (customerId === '') {
                delete params.customerId;
            }
            return params;
        },

        // 상담목록 가져오기
        async fetchConsultList() {
            try {
                this.consultListIsLoading = true;
                const { data } = await this.sendGetConsult();
                this.consultListInfo = data.items;
                this.setPageParams(data);
                this.consultListIsLoading = false;
            } catch (error) {
                alert('상담 목록을 불러오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 상담 목록 조회 API
        sendGetConsult() {
            const {
                consultPath,
                infoPath,
                consultTypeId,
                centerStaffId,
                customerYn,
                searchStr,
                startDate,
                endDate,
                customerId,
            } = this;
            const searchParams = {
                consultPath,
                infoPath,
                consultTypeId,
                centerStaffId,
                customerYn,
                searchStr,
                startDate,
                endDate,
                customerId,
            };

            return api.get(`/admin/api/center/${this.centerId}/consult`, {
                params: {
                    ...this.consultPagingInfo,
                    ...searchParams,
                },
            });
        },

        // 페이징 Param set
        setPageParams(data) {
            this.consultPagingInfo.totalPages = data.meta.totalPages;
            this.consultPagingInfo.page = data.meta.currentPage;
            this.consultPagingInfo.totalItems = data.meta.totalItems;
            this.consultPagingInfo.itemCount = data.meta.itemCount;
        },

        // 상담경로 변환
        convertConsultPath(path) {
            if (path === 'T') {
                return '전화';
            } else if (path === 'V') {
                return '방문';
            } else if (path === 'M') {
                return '메세지';
            } else if (path === 'K') {
                return '카카오톡';
            } else if (path === 'O') {
                return '온라인';
            } else if (path === 'E') {
                return '기타';
            }
        },

        // 유입경로 변환
        convertInfoPath(path) {
            if (path === 'P') {
                return '전단지';
            } else if (path === 'S') {
                return 'SNS';
            } else if (path === 'B') {
                return '블로그';
            } else if (path === 'H') {
                return '홈페이지';
            } else if (path === 'I') {
                return '지인소개';
            } else if (path === 'E') {
                return '기타';
            }
        },

        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({ path: `${path}/${this.centerId}`, query: { customerId: this.customerId } });
        },

        // 페이지 변경 Handler
        handlerPagenation(event, pagingType) {
            if (pagingType === 'consult') {
                this.consultPagingInfo.page = event;
                this.fetchConsultList();
            }
        },

        // 상담유형 설정 팝업에서 취소 버튼 클릭시
        async onClickCancleConsultType() {
            this.adviceSettingPop = false;
            await this.fetchConsultType();
        },

        // 상담유형 설정 팝업에서 저장 버튼 클릭시
        async onClickSaveConsultType() {
            const validate = this.validateConsultTypeValues();
            if (!validate.result) {
                alert(validate.msg);
                this.$nextTick(function () {
                    this.$refs.consultTypeArray[validate.resultIndex].focus();
                });
                return;
            }
            try {
                this.consultPopupLoading = true;
                const { data } = await this.sendPostSaveConsultType();
                alert('상담유형을 저장했습니다.');
                await this.fetchConsultType(); // 상담유형 다시 불러오기
                this.consultPopupLoading = false;
            } catch (error) {
                alert('상담유형 저장 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 상담유형 저장 API 호출
        sendPostSaveConsultType() {
            return api.post(`/admin/api/center/${this.centerId}/consult-type`, {
                ...this.consultTypeList,
            });
        },

        // 상담유형 설정 팝업 수정, 등록 validation
        validateConsultTypeValues() {
            const msg = '상담유형을 다시 확인하세요.';
            let result = true;
            let resultIndex = '';
            this.$refs.consultTypeArray.some((c, index) => {
                if (c.value.replaceAll(' ', '').length === 0 || c.value.length < 2) {
                    result = false;
                    resultIndex = index;
                    return true;
                }
            });
            return { result, resultIndex, msg };
        },

        // 상담유형 삭제 버튼 클릭시
        async onClickDeleteConsultType(consultTypeId, index) {
            if (!confirm('상담유형을 삭제하시겠습니까?')) {
                return false;
            }
            try {
                if (consultTypeId === undefined) {
                    this.consultTypeList.types.splice(index, 1);
                } else {
                    this.consultPopupLoading = true;
                    await this.sendDeleteConsultType(consultTypeId);
                    alert('상담유형을 삭제했습니다.');
                    await this.fetchConsultType();
                    this.consultPopupLoading = false;
                }
            } catch (error) {
                alert('상담유형 삭제 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 상담유형 삭제 API 호출
        sendDeleteConsultType(consultTypeId) {
            return api.delete(`/admin/api/center/${this.centerId}/consult-type/${consultTypeId}`);
        },

        // 상담유형 추가 버튼 클릭시
        onClickAddConsultType() {
            this.consultTypeList.types.push({
                consultTypeName: '',
            });
        },

        // 검색 시작일 초기화
        initStartDate() {
            const startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
            this.startDate = startDate;
        },

        // 검색 종료일 초기화
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            this.endDate = endDate;
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.fetchConsultList();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.fetchConsultList();
        },

        // 검색 조건 초기화
        resetSearchParams() {
            this.initStartDate(); // 시작일 검색 파라미터
            this.initEndDate(); // 종료일 검색 파라미터
            (this.consultTypeId = ''), // 상담유형 검색 파라미터
                (this.centerStaffId = ''), // 상담자 검색 파라미터
                (this.searchPeriod = ''), // 기간 파라미터
                this.fetchConsultList();
            EventBus.$emit('event:initList', 'init');
        },

        // 상담 내용 상세보기 버튼 클릭시
        async onClickModifyConsult(centerId, consultId) {
            this.advicePop = true;
            try {
                this.detailConsultId = consultId;
                this.detailConsultLoading = true;
                const { data } = await this.fetchConsultDetail(centerId, consultId);
                this.consultDetailInfo = data;
                const { consultDetailInfo, detailEditField } = this;
                detailEditField.centerConsultFunnelId = consultDetailInfo.centerConsultFunnelId;
                detailEditField.customerNme = consultDetailInfo.customerNme;
                detailEditField.centerStaffId = consultDetailInfo.centerStaffId;
                detailEditField.consultedAt = consultDetailInfo.consultedAt;
                detailEditField.consultTypeId = consultDetailInfo.consultTypeId;
                detailEditField.consultTypeName = consultDetailInfo.consultTypeName;
                detailEditField.consultPath = consultDetailInfo.consultPath;
                detailEditField.memo = consultDetailInfo.memo;
                this.detailConsultLoading = false;
            } catch (error) {
                alert('상담 내용을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 상담 관리 조회
        fetchConsultDetail(centerId, consultId) {
            return api.get(`/admin/api/center/${centerId}/consult/${consultId}`);
        },

        // 상담 내용 삭제 버튼 클릭시
        async onClickDeleteConsult(centerId, consultId) {
            try {
                if (!confirm('상담을 삭제하시겠습니까?')) {
                    return false;
                }
                this.consultListIsLoading = true;
                await this.sendDeleteConsult(centerId, consultId);
                alert('상담을 삭제했습니다.');
                await this.fetchConsultList();
                this.consultListIsLoading = false;
            } catch (error) {
                alert('상담 삭제 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 상담 삭제 API 호출
        sendDeleteConsult(centerId, consultId) {
            return api.delete(`/admin/api/center/${centerId}/consult/delete/${consultId}`);
        },

        // 상담 내용 팝업 수정 버튼 클릭시
        async onClickSaveConsultDetail() {
            try {
                this.detailConsultLoading = true;
                const { data } = await this.sendPutConsultDetail();
                alert('상담 내용이 수정 되었습니다.');
                this.detailConsultLoading = false;
                this.advicePop = false;
                await this.fetchConsultList();
                this.initDetailEditField();
            } catch (error) {
                alert('상담 내용 수정 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터상담관리 수정 API 호출
        sendPutConsultDetail() {
            const elements = document.querySelectorAll('.ck-editor__editable');

            // // 선택된 모든 요소의 텍스트 내용을 순차적으로 출력
            // elements.forEach(function(element, index) {
            //     console.log(`Element ${index + 1}:`, element.textContent);
            // });
            const domEditableElement = elements[1];
            const editorInstance = domEditableElement.ckeditorInstance;
            this.detailEditField.memo = editorInstance.getData();

            return api.put(`/admin/api/center/${this.centerId}/consult/${this.detailConsultId}`, {
                ...this.detailEditField,
            });
        },

        // 상담 내용 팝업 취소 버튼 클릭시
        onClickCancleConsultDetail() {
            this.advicePop = false;
        },

        // 상담내용수정 화면 > 상담유형 select-form 변경시
        onChangeDetailConsultType(val) {
            const index = this.consultTypeList.types.findIndex((c) => c.centerConsultTypeId === val); // consultTypeId로 consultTypeName을 찾기 위해 index를 구함
            this.detailEditField.consultTypeName = this.consultType[index];
            this.detailEditField.consultTypeId = val;
        },

        // 회원 정보 카드에 나타낼 회원 그룹 이름 만들기
        convertTeamGroupsToString(teamGroups) {
            if (teamGroups === undefined) {
                return;
            }
            if (teamGroups.length === 1) {
                // 그룹이 1개일 경우
                return teamGroups[0].centerCustomerTeamName;
            } else if (teamGroups.length === 0) {
                // 그룹이 없을 경우
                return '-';
            } else if (teamGroups.length > 1) {
                // 그룹이 여러개일 경우
                return `${teamGroups[0].centerCustomerTeamName} 외 ${teamGroups.length - 1}`;
            }
        },

        splitPhoneNumber(phoneNumber) {
            if (!phoneNumber) return phoneNumber;

            phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

            const tmp = ['', '', ''];
            if (phoneNumber.length < 4) {
                return phoneNumber;
            } else if (phoneNumber.length < 7) {
                tmp[0] = phoneNumber.substr(0, 3);
                tmp[1] = phoneNumber.substr(3);
            } else if (phoneNumber.length === 8) {
                tmp[0] = phoneNumber.substr(0, 4);
                tmp[1] = phoneNumber.substr(4);
            } else if (phoneNumber.length < 10) {
                if (phoneNumber.substr(0, 2) === '02') {
                    // 02-123-5678
                    tmp[0] = phoneNumber.substr(0, 2);
                    tmp[1] = phoneNumber.substr(2, 3);
                    tmp[2] = phoneNumber.substr(5);
                }
            } else if (phoneNumber.length < 11) {
                if (phoneNumber.substr(0, 2) == '02') {
                    // 02-1234-5678
                    tmp[0] = phoneNumber.substr(0, 2);
                    tmp[1] = phoneNumber.substr(2, 4);
                    tmp[2] = phoneNumber.substr(6);
                } else {
                    // 010-123-4567
                    tmp[0] = phoneNumber.substr(0, 3);
                    tmp[1] = phoneNumber.substr(3, 3);
                    tmp[2] = phoneNumber.substr(6);
                }
            } else {
                // 010-1234-5678
                tmp[0] = phoneNumber.substr(0, 3);
                tmp[1] = phoneNumber.substr(3, 4);
                tmp[2] = phoneNumber.substr(7);
            }
            return tmp;
        },

        handleCloseContractSend() {
            this.contractSendPop = false;
        },

        handleCharge() {
            this.contractSendPop = false;
        },

        handlePaymentLinkSend() {
            this.contractSendPop = false;

            this.onClickRouter('/madmin/member/contract_send');
        },

        showContractSendPopup() {
            this.contractSendInfo = {
                centerId: this.centerId,
                centerName: this.centerInfo.centerName,
                customerId: this.customerId,
                customerName: this.customerInfo.name,
                customerPhone: this.customerInfo.phone,
                templateType: 'M',
            };
            this.contractSendPop = true;
        },
    },
};
</script>
<style lang="scss" scoped>
p {
}
</style>
